import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { captureRedirectUrl, getPostLoginRedirectUrl } from '../utils/redirectUtils';

/**
 * Hook for managing login redirects
 */
export const useRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setRedirectAfterLogin, getAndClearRedirectUrl } = useAuthStore();

  /**
   * Capture current URL for post-login redirect
   */
  const captureCurrentUrl = () => {
  const url = captureRedirectUrl(location as any);
    setRedirectAfterLogin(url);
    return url;
  };

  /**
   * Navigate to login with current URL captured
   */
  const redirectToLogin = (loginPath = '/login') => {
    captureCurrentUrl();
    navigate(loginPath, {
      state: { from: location as any },
      replace: true
    });
  };

  /**
   * Get the best redirect URL after login
   */
  const getRedirectUrl = () => {
    const storeUrl = getAndClearRedirectUrl();
    const locationUrl = location.state?.from?.pathname;
    return getPostLoginRedirectUrl(storeUrl, locationUrl);
  };

  /**
   * Redirect to the appropriate page after login
   */
  const redirectAfterLogin = () => {
    const url = getRedirectUrl();
    navigate(url, { replace: true });
  };

  return {
    captureCurrentUrl,
    redirectToLogin,
    getRedirectUrl,
    redirectAfterLogin,
  };
};